<template>
  <div id="app" :dir="dir">
     <Loader />
    <!-- <Languages class="languages"></Languages> -->
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

// import Languages from './components/Languages'
import Loader from './components/Loader'

require('material-design-lite')

export default {
  name: 'app',
  components: {
    // Languages,
    Loader
  },
  computed: {
    ...mapGetters([
      'dir'
    ])
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/icon?family=Material+Icons');
@import url('https://code.getmdl.io/1.2.1/material.blue-red.min.css');

#app {
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  font-family: 'Lato', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color:black;
  font-size: 16px;
}
body, * {
  margin: 0;
  box-sizing: border-box;
}
.full-screen {
    width: 100%;
    height: 100vh;
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: center center !important;
}
.cursor {
  cursor: pointer;
}

.back-drop {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0,0,0, 0.6);
    z-index: 6;
}
    ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
        color: #812d03;
    }
    ::-moz-placeholder { /* Firefox 19+ */
        color: #812d03;
    }
    :-ms-input-placeholder { /* IE 10+ */
        color: #812d03;
    }
    :-moz-placeholder { /* Firefox 18- */
        color: #812d03;
    }
    form {
        width: 250px;
        display: flex;
        flex-direction: column;
        /*background-color: rgba(255, 255, 255, 0.62);*/
    }
    .reports-section {
        /*display: flex;
        flex-wrap: wrap;*/
        /*background: linear-gradient(180deg,#02b3e4 0,#02ccba 100%);*/
        /* background: linear-gradient(180deg,#5f94a2 0,#02ccba 100%); */
        padding: 25px 100px;
    }
    .flex-center {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .flex {
        display: flex;
        align-items: center;
    }
    .flex-between {
        justify-content: space-between;
    }
    .flex-align-top {
        align-items: flex-start;
    }
    .btn-bg1 {
      background-color: rgba( 167, 57, 75,0.42 );
      box-shadow: inset 0.5px 0.866px 3px 0px rgb( 133, 36, 51 );
      box-shadow: inset -0.5px -0.866px 3px 0px rgb( 133, 36, 51 );
      width: 180px;
      height: 54px;
      border-radius: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
      margin-top: 80px;
      min-height: 54px;
    }
    .btn-bg2 {
      background: rgba(183,62,78,1);
      background: -moz-linear-gradient(top, rgba(183,62,78,1) 0%, rgba(223,91,109,1) 100%);
      background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(183,62,78,1)), color-stop(100%, rgba(223,91,109,1)));
      background: -webkit-linear-gradient(top, rgba(183,62,78,1) 0%, rgba(223,91,109,1) 100%);
      background: -o-linear-gradient(top, rgba(183,62,78,1) 0%, rgba(223,91,109,1) 100%);
      background: -ms-linear-gradient(top, rgba(183,62,78,1) 0%, rgba(223,91,109,1) 100%);
      background: linear-gradient(to bottom, rgba(183,62,78,1) 0%, rgba(223,91,109,1) 100%);
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#b73e4e', endColorstr='#df5b6d', GradientType=0 );
      width: 172px;
      height: 46px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 30px;
      box-shadow: inset 0.5px 0.866px 3px 0px rgb( 133, 36, 51 );
    }
    button.login {
      background: rgba(255,255,255,1);
      background: -moz-linear-gradient(top, rgba(255,255,255,1) 0%, rgba(253,196,152,1) 100%);
      background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(255,255,255,1)), color-stop(100%, rgba(253,196,152,1)));
      background: -webkit-linear-gradient(top, rgba(255,255,255,1) 0%, rgba(253,196,152,1) 100%);
      background: -o-linear-gradient(top, rgba(255,255,255,1) 0%, rgba(253,196,152,1) 100%);
      background: -ms-linear-gradient(top, rgba(255,255,255,1) 0%, rgba(253,196,152,1) 100%);
      background: linear-gradient(to bottom, rgba(255,255,255,1) 0%, rgba(253,196,152,1) 100%);
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#fdc498', GradientType=0 );
      box-shadow: 1px 1.732px 2px 0px rgb( 183, 62, 78 );
      width: 170px;
      height: 44px;
      border: none;
      border-radius: 30px;
      outline: none;
      font-size: 17px;
      font-family: "Lato";
      color: rgb( 183, 62, 78 );
      font-weight: bold;
      text-align: center;
      text-shadow: 0.5px 0.866px 0px rgb( 227, 247, 243 );
    }
    .danger {
      color: #ff971c;
    }
    .relative {
      position: relative;
    }

  .in-sentence-rearange {
    display: none;
  }
  div[dir='rtl'] .in-sentence {
    display: none;
  }
  div[dir='rtl'] .in-sentence-rearange {
    display: flex;
  }
  .heding-color {
    color:#812d03
  }
  .heading {
      font-size: 36px;
    }
  /* .heading {
    font-size: 800%;
  } */
  .top-mrgn {
    margin-top:77px;
  }
  .input-btm-mrg {
    margin-bottom: 45px;
  }

  .error-msg {
    color: rgba(129, 45, 3, 0.75);
    position: absolute;
    z-index: 6;
    bottom: 15px;
    font-size: 16px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 0;
    width: 100%;
  }
  .app-bg-gradient {
    background: rgba(254,158,85,0.84);
    background: -moz-linear-gradient(top, rgba(254,158,85,0.84) 0%, rgba(202,61,89,0.84) 100%);
    background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(254,158,85,0.84)), color-stop(100%, rgba(202,61,89,0.84)));
    background: -webkit-linear-gradient(top, rgba(254,158,85,0.84) 0%, rgba(202,61,89,0.84) 100%);
    background: -o-linear-gradient(top, rgba(254,158,85,0.84) 0%, rgba(202,61,89,0.84) 100%);
    background: -ms-linear-gradient(top, rgba(254,158,85,0.84) 0%, rgba(202,61,89,0.84) 100%);
    background: linear-gradient(to bottom, rgba(254,158,85,0.84) 0%, rgba(202,61,89,0.84) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fe9e55', endColorstr='#ca3d59', GradientType=0 );
  }
  .footer {
    position: absolute;
    bottom: 10px;
    right: 20px;
    letter-spacing: 2px;
    font-size: 14px;
    font-weight: bold;
    color: #FFF;
    opacity: 0.5;
  }
  .stars-bg {
    background-image: url('/static/images/background-stars.png');
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
  select {
    background-image: url('/static/images/drop-down-arrow.png');
    background-repeat: no-repeat;
    background-position: 100% 60%;
    background-size: 14px;
  }
  div[dir='rtl'] .select {
    background-position: 10% 60%;
  }

  .stars, .stars-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-image: url('/static/images/background-stars.png');
    background-repeat: no-repeat !important;
    background-size: 100% auto !important;
    z-index: 1;
  }
  .numpad-layour button.numpad {
    background-image: url(/static/images/numpad-button.png);
    background-size: 65%;
    background-position: center center;
    background-repeat: no-repeat;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    color: #000;
    font-size: 26px;
    font-weight: 600;
    cursor: pointer;
    background-color: transparent !important;
    border: none;
    outline: none;
    width: calc(100% / 3);
    height: calc(100% / 4);
  }
  .numpad-layour .keypad button {
    background-image: url(/static/images/keyboard-button.png);
    background-size: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    color: #000;
    font-size: 18px;
    font-weight: 600;
    cursor: pointer;
    background-color: transparent !important;
    border: none;
    outline: none;
  }
  .numpad-layour .keypad.numbers button, .numpad-layour .keypad.alphabets button{
    width: calc(100% / 12);
    height: 50px;
  }
  .keypad.otherkeys button {
    width: 50%;
    height: 50px;
    background-image: url(/static/images/spacebar.png);
    background-size: 100% 48px;
  }
  .keypad.otherkeys1 button {
    width: calc(100% / 12);
    height: 50px;
    background-image: url(/static/images/keyboard-button.png);
  }
  .keypad.otherkeys1 button:first-child,.keypad.otherkeys1 button:last-child {
    visibility: hidden;
    background-size: 100% 48px;
  }
  .keypad.otherkeys1 button:nth-child(3) {
    width: 66.67%;
    background-image: url(/static/images/spacebar.png);
    background-size: 104% 45px
  }
  .keypad.otherkeys1 button:nth-child(4) {
    font-size: 12px;
  }
  @media only screen and (min-width: 2000px) {
    .numpad-layour .keypad button {
      background-size: 89%;
      font-size: 110px;
    }
    /* For mobile phones: */
    .heading {
      font-size: 100px;
      margin-bottom:90px;
    }
    .btn-bg1 {
      width: 450px;
      height: 150px;
      border-radius: 77px;
    }
    .btn-bg2 {
      width: 436px;
      height: 138px;
      border-radius: 77px;
    }
    button.login {
      width: 421px;
      height: 128px;
      font-size: 55px;
      border-radius: 77px;
    }
    .input-btm-mrg {
      margin-bottom: 17%;
    }
    .top-mrgn {
      margin-top: 17%;
    }
    form {
      padding: 10% 5% !important;
    }
    form .btn-bg1 {
      margin-top: 260px;
    }
      .mosque-name {
        font-size: 180px !important;
        line-height: 230px !important;
        margin-top: 10% !important;
        margin-bottom: 5% !important;
        letter-spacing: 6px !important;
      }
      .hint {
        font-size: 100px !important;
        line-height: 120px !important;
        margin-bottom: 5% !important;
        letter-spacing: 6px !important;
      }
      .reports-section {
        height: 60vh !important;
        width: 80% !important;
      }
      .footer {
        font-size: 75px !important;
        line-height: 75px !important;
        bottom: 100px !important;
        right: 5% !important;
      }
      .amount-select-section {
        height:50vh !important;
      }
      .numpad-layour .keypad.numbers button, .numpad-layour .keypad.alphabets button {
        height: 300px;
      }
      .keypad.otherkeys {
        margin-top: 5px;
      }
      .keypad.otherkeys button {
        height: 280px;
        background-size: 100% 280px;
      }
      .keypad.otherkeys1 button {
        height: 300px;
      }
      .keypad.otherkeys1 button:nth-child(3) {
        height: 280px;
        background-size: 94% 270px;
      }
      .keypad.otherkeys1 button:nth-child(4) {
        font-size: 85px;
        font-weight: bold;
      }
      .numpad-layour button.numpad {
       font-size: 90px;
       font-weight: 900;
       background-size: 90%;
      }
      .full-screen {
        background-size: 100% 100%;
        background-position: center;
      }
      .error-msg {
        font-size: 90px;
        line-height: 90px;
        bottom: 10%;
      }
      div[dir='rtl'] .footer {
        right: inherit !important;
        left: 5%;
      }
  }
 @media screen and (min-width: 1200px) and (min-height: 904px) {
   .mosque-name {
     font-size: 50px !important;
     margin-top: 80px !important;
     line-height: 50px;
   }
   .hint {
    font-size: 30px !important;
     line-height: 35px !important;
   }
   .numpad-layour button.numpad {
     background-size: 75%;
   }
   .numpad-layour .keypad.numbers button, .numpad-layour .keypad.alphabets button {
     height: 70px;
   }
   .keypad.otherkeys button {
     height: 70px;
     background-size: 100% 83px;
   }
   .keypad.otherkeys.otherkeys1 button {
     background-size: 100%;
   }
   .keypad.otherkeys1 button:nth-child(3) {
     background-size: 100% 84px;
   }
   .numpad-layour .keypad {
     margin-bottom: 11px;
   }
  .numpad-layour .keypad button {
    font-size: 28px
  }
  .mosque-login-details .login .form-class form {
    max-height: 500px;
  }
  .keypad.otherkeys1 button:nth-child(4) {
    font-size: 22px;
  }
  div[dir='rtl'] .footer {
    right: initial;
    left: 20px;
  }
 }
</style>



// WEBPACK FOOTER //
// src/App.vue